// extracted by mini-css-extract-plugin
export default {"root":"Breadcrumb_root__OYiTR","divider":"Breadcrumb_divider__PdHmX","link":"Breadcrumb_link__VlW6z"};